module.exports = __webpack_public_path__ + "static/img/staticimage.f80304a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/staticimage.png
// module id = v4mN
// module chunks = 9